import NoveltyDividend from '../../../Model/NoveltyDividend'

export class NoveltyDividendsViewModel {
  public noveltyDividends: ko.ObservableArray<NoveltyDividend>

  constructor(params: { noveltyDividends: ko.ObservableArray<NoveltyDividend> }) {
    this.noveltyDividends = params.noveltyDividends
  }
}
